<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form inline :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
       
      <el-form-item label="产品" prop="product">
          <renSelect v-model="dataForm.product" :disabled="dataForm.id" dictType="loan_type" placeholder="产品"></renSelect>
      </el-form-item>
      <el-form-item label="城市" prop="city">
          <w-city v-model="dataForm.city" :disabled="dataForm.id" defaultUrl="/sys/productpricing/accessToAccess" placeholder="城市"></w-city>
      </el-form-item>
        
      <el-form-item label="定价" class="styW" prop="productPricing" >
          <el-input type="number" v-model="dataForm.productPricing" placeholder="产品定价"></el-input>
      </el-form-item>
      <el-form-item label="生效日期" prop="effectiveDate">
        <el-date-picker
                  v-model="dataForm.effectiveDate"
                  disabled
                  type="date"
                 
                  placeholder=""
                  value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        
      </el-form-item>
   
   
  
 
       
         
      </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        id: '',
        effectiveDate: '',
        product: '',
        city: '',
        finalStatus: '',
        status: '',
        productPricing: '',
        reviewersStatus: '',
        reviewers: '',
       
      }
    }
  },
  computed: {
    dataRule () {
      return {
        effectiveDate: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        product: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        city: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        finalStatus: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        status: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        productPricing: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
       
        reviewersStatus: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        reviewers: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
    
      }
    }
  },
  methods: {
    init () {
      this.visible = true
    
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }else{
          if(this.isNextDayAfter5pm()){
            this.getTime(2)
          }else{
            this.getTime(1)
          }
         
        }
      })
    },
      // 判断时间是否选的次日超过下午五点
      isNextDayAfter5pm(hour = 17) {
        let now = new Date();
        var currentHour = now.getHours();
       
        return currentHour >= hour;
     
    },
    // 获取信息
    getTime(dates){
      let now = new Date();
      now.setDate(now.getDate() + dates);
      let year = now.getFullYear(); // 获取四位数的年份，例如 2023
      let month = now.getMonth() + 1; // 获取当前月份，范围为 0-11，需要加上 1
      let date = now.getDate(); // 获取当前日期
      let hours = now.getHours(); // 获取当前小时数，范围为 0-23
      let minutes = now.getMinutes(); // 获取当前分钟数，范围为 0-59
      let seconds = now.getSeconds(); // 获取当前秒数，范围为 0-59
      month = month < 10 ? '0' + month : month
      date = date < 10 ? '0' + date : date
      hours = hours < 10 ? '0' + hours : hours
      minutes = minutes < 10 ? '0' + minutes : minutes
      seconds = seconds < 10 ? '0' + seconds : seconds
      // // console.log(year + "-" + month + "-" + date + " " + hours + ":" + minutes + ":" + seconds);
      this.dataForm.effectiveDate = year + "-" + month + "-" + date + " " + hours + ":" + minutes + ":" + seconds
      // return  year + "-" + month + "-" + date + " " + hours + ":" + minutes + ":" + seconds
      // this.dataForm.effectiveDate = year + "-" + month + "-" + date
    },
    getInfo () {
      this.$http.get(`/sys/productpricing/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
       
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/productpricing/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
